/*
 * @Author: atdow
 * @Date: 2024-01-08 11:31:36
 * @LastEditors: null
 * @LastEditTime: 2025-09-22 18:51:32
 * @Description: file description
 */
import { defineStore } from 'pinia'
import { ADMIN_INFO } from '/@/stores/constant/cacheKey'
import { AdminInfo } from '/@/stores/interface'
import { Local } from '/@/utils/storage'
import { login, oldLinkedTokenLogin } from '/@/api/login'

export const useAdminInfo = defineStore('adminInfo', {
  state: (): AdminInfo => {
    return {
      userId: 0,
      account: '',
      userName: '',
      name: '',
      nickName: '',
      realName: '',
      avatar: '',
      phone: '',
      customerName: '',
      customerId: '',
      lastlogintime: '',
      token: '',
      refreshToken: '',
      countType: 0,
      roleListId: [],
      roleDto: {},
      roleMenu: [],
      // 是否是superAdmin，用于判定是否显示终端按钮等，不做任何权限判断
      super: false
    }
  },
  actions: {
    // 登录
    login (userInfo: anyObj) {
      return new Promise((resolve, reject) => {
        const { account, name } = userInfo
        login(userInfo)
          .then(res => {
            const { token } = res.content || {}
            this.token = token
            this.dataFill(<AdminInfo>{ ...res.content, account, name })
            this.setToken(token, 'token')
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    oldLinkedTokenLogin (oldLinkedToken: string) {
      return new Promise((resolve, reject) => {
        oldLinkedTokenLogin({ oldLinkedToken })
          .then(res => {
            const { token } = res.content || {}
            if (!token) {
              reject(new Error('登录失败'))
              return
            }

            this.token = token
            this.dataFill(<AdminInfo>{ ...res.content })
            this.setToken(token, 'token')
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    dataFill (state: AdminInfo) {
      this.$state = { ...this.$state, ...state }
    },
    removeToken () {
      return new Promise(resolve => {
        this.token = ''
        this.refreshToken = ''
        Local.remove(ADMIN_INFO)
        resolve(true)
      })
    },
    setToken (token: string, type: 'token' | 'refreshToken') {
      this[type] = token
    },
    getToken (type: 'auth' | 'refresh' = 'auth') {
      return type === 'auth' ? this.token : this.refreshToken
    },
    getName (): string {
      return this.name
    },
    setSuper (val: boolean) {
      this.super = val
    }
  },
  persist: {
    key: ADMIN_INFO
  }
})
